__turbopack_context__.v({
  "fireIcon": "FulfillmentStockLevelRow-module-scss-module__W84CMW__fireIcon",
  "fitContent": "FulfillmentStockLevelRow-module-scss-module__W84CMW__fitContent",
  "stockLevelContainer": "FulfillmentStockLevelRow-module-scss-module__W84CMW__stockLevelContainer",
  "stockLevelMessage": "FulfillmentStockLevelRow-module-scss-module__W84CMW__stockLevelMessage",
});
